export default __webpack_public_path__ + "static/media/jap-ecommerceImg_8.4bd0615a.webp";